import * as actions from './actionTypes'


//点击添加设备状态可点击或者不可点击
export const setSelPmu=(pmu)=>({
  type:actions.SEL_PMU,
  data:pmu,
})

